import React from "react";
import detector from "detector";

import routing from "../../routing";
import { christmasId } from "../../../common/parameters";
import Seo from "../../../common/helpers/seo";
import AfterHydration from "../../../common/helpers/afterHydration";
import Game from "./Game";
import { seoImageUrl } from "./utils";
import { IProps } from "./interfaces";

class ChristmasTuning extends React.Component<IProps> {
    componentDidMount() {
        if (detector.os.name !== "ios") {
            document.body.style.overflowY = "hidden";
        }
        setTimeout(() => {
            this.props.getPlan("/" + routing.publicPlan + "/" + christmasId, () => {});
        }, 10000);
    }
    componentWillUnmount() {
        document.body.style.overflowY = "";
    }
    render() {
        const { formatMessage } = this.props.intl;
        // The game adds a resize listener while it is being constructed, so it cannot be
        // built on the server - nor in the browser's first render, which is the one that
        // has to match the markup the server sent.
        return (
            <AfterHydration>
                {() => (
                    <>
                        <Seo
                            title={formatMessage({ id: "christmas.title" })}
                            description={formatMessage({ id: "christmas.seo" })}
                            image={seoImageUrl}
                        />
                        <Game />
                    </>
                )}
            </AfterHydration>
        );
    }
}

export default ChristmasTuning;
